import { TestDefinition, QuestionType } from '../../types';

// Y-BOCS scale 0-4
const ybocsScale = [
  { label: '0 - None', value: 0 },
  { label: '1 - Mild', value: 1 },
  { label: '2 - Moderate', value: 2 },
  { label: '3 - Severe', value: 3 },
  { label: '4 - Extreme', value: 4 }
];

export const TESTS_TOC: TestDefinition[] = [
  {
    id: 'ybocs',
    code: 'Y-BOCS',
    name: 'Yale-Brown Obsessive Compulsive Scale',
    category: 'OCD',
    description: 'A 10-item scale to assess severity of obsessive-compulsive symptoms. Developed by Goodman et al. (1989). Evaluates 5 dimensions of obsessions and 5 of compulsions: time, interference, distress, resistance, and control.',
    questions: [
      // OBSESSIONS (5 items)
      {
        id: 'o1',
        text: '1. Time occupied by obsessive thoughts',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsessions'
      },
      {
        id: 'o2',
        text: '2. Interference due to obsessive thoughts',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsessions'
      },
      {
        id: 'o3',
        text: '3. Distress associated with obsessive thoughts',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsessions'
      },
      {
        id: 'o4',
        text: '4. Resistance against obsessions',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsessions'
      },
      {
        id: 'o5',
        text: '5. Degree of control over obsessive thoughts',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsessions'
      },

      // COMPULSIONS (5 items)
      {
        id: 'c1',
        text: '6. Time spent performing compulsive behaviors',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsions'
      },
      {
        id: 'c2',
        text: '7. Interference due to compulsive behaviors',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsions'
      },
      {
        id: 'c3',
        text: '8. Distress associated with compulsive behavior',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsions'
      },
      {
        id: 'c4',
        text: '9. Resistance against compulsions',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsions'
      },
      {
        id: 'c5',
        text: '10. Degree of control over compulsive behaviors',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsions'
      }
    ],
    subscales: [
      {
        name: 'Obsessions',
        questionIds: ['o1', 'o2', 'o3', 'o4', 'o5'],
        description: 'Time, interference, distress, resistance and control of obsessive thoughts'
      },
      {
        name: 'Compulsions',
        questionIds: ['c1', 'c2', 'c3', 'c4', 'c5'],
        description: 'Time, interference, distress, resistance and control of compulsive behaviors'
      }
    ],
    interpretations: [
      { min: 0, max: 7, label: 'Subclinical', color: 'bg-green-100 text-green-800' },
      { min: 8, max: 15, label: 'Mild OCD', color: 'bg-yellow-100 text-yellow-800' },
      { min: 16, max: 23, label: 'Moderate OCD', color: 'bg-orange-100 text-orange-800' },
      { min: 24, max: 31, label: 'Severe OCD', color: 'bg-red-100 text-red-800' },
      { min: 32, max: 40, label: 'Extreme OCD', color: 'bg-red-200 text-red-900' }
    ]
  }
];
